module.exports = __webpack_public_path__ + "img/dark-personal-portfolio-landing.72da54b5.png";